import ApprovedDocumentsActions from './ApprovedDocumentsActions';
import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { DOC2SIGN_DOCUMENT_TYPE } from '../constants';
import { LangContext } from "../LangContext.jsx";
import DocumentsActions from "./DocumentsActions.jsx";
class DossierDocumentsTable extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
        };
    }
    traducirPalabra = (palabra)=>{ 
        const { lang } = this.context;  
        if(palabra == '(es)'){
            return '';
        }
        return lang.get('messages.'+palabra.toLowerCase().replace(/\s+/g, '_').replace(/\s+/g, '_').replace(/[()]/g, '').normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '').replace(/,/g, ''))
    }
    translatePeriod = (texto) => {
        if (texto === null || texto === undefined) {
            return ''; 
            }
            const palabras = texto.split(/\s+/);
            const textoTraducido = palabras.map((palabra) => this.traducirPalabra(palabra)).join(' ');
            return textoTraducido;
    }
    render() {
        const { lang } = this.context; 
        return (
            <>
                {this.props.showRejectedMessage ? (
                <>
                    <tr>
                        <td colSpan="5">
                            <div className="separator separator-solid separator-border-1 mt-5 mb-2" style={{ borderBottomColor: "#dbcbfd" }}></div>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="2"> <h5 className="py-5">{this.props.title}</h5> </td>
                        <td colSpan="2"> <div className="pb-5"><b>{lang.get('messages.motivo_de_rechazo')}</b></div> </td>
                        <td colSpan="2"></td>
                    </tr>
                </>
                ) : (
                <tr>
                    <td colSpan="5">
                        <div className="separator separator-solid separator-border-1 mt-5 mb-2" style={{ borderBottomColor: "#dbcbfd" }}></div>
                        <h5 className="py-5">{this.props.title}  </h5>
                    </td>
                </tr>
                )}
                {this.props.documents?.map((d, i) => (
                <tr key={i}>
                    <td style={{width: "20px"}}>
                        {
                            d.document.type_id == DOC2SIGN_DOCUMENT_TYPE
                                ? <img src="/assets/img/doc2sign.svg"/>
                                : <img src={"/assets/img/" + window.getMimeSVG(d?.file.extension!=undefined ? d?.file.extension : d?.file.path)} />
                        } 
                    </td>
                    <td colSpan={this.props.showRejectedMessage ? "" : "2"}>  
                        {`${d.document.title} ${d.document.version > 1 ? `V${d.document.version}` : ''}`} 
                        {this.props.type == "recurrent"   &&
                        <span className="tooltip-mdl">
                            <span><strong> &nbsp; - {d.description_period}  </strong></span> 
                                <span className="tooltip-text-mdl">{this.translatePeriod(d.document.period) }</span> 
                        </span>  
                        }  
                        &nbsp;
                        { (d.document_dossier_state_id == 2 && this.props.type == "recurrent") &&
                            <span class="badge badge-incompleto">{lang.get('messages.recurrencia_suspendida')}</span>
                        }
                        <div className="text-dark-65 font-size-sm">
                        ({lang.get('messages.solicitado_el')} {d.requestedDate}
                        { (d?.upload_date?.created && d.document.type_id !== DOC2SIGN_DOCUMENT_TYPE && d.document.type_id !== 2) && (
                            <> - {lang.get('messages.cargado_el')} {d.upload_date.created} </>
                        )} 
                        { (d?.approval_date.created != null && d.document.type_id !== DOC2SIGN_DOCUMENT_TYPE )&& (
                            <> - {lang.get('messages.aprobado_el')} {d.approval_date.created} </>
                        )}
                        
                        { (d?.rejected_date.created != null &&  this.props.title == 'Rechazados')&& (
                            <> - {lang.get('messages.rechazado_el')} {d.rejected_date.created} </>
                        )}
                        
                        { d?.signed_date != null && (
                            <> - {lang.get('messages.firmado_el')} {d.signed_date.created} </>
                        )}
                        
                        )
                        </div>
                    </td>
                    {this.props.showRejectedMessage &&
                    <>
                        <td colSpan="2">  {d?.status_comment}</td>
                    </> }  
                    {(
                    (this.props.title == 'Aprobados / Firmados' || this.props.title == 'Aprobados')  
                    ) && (
                    <>
                        <ApprovedDocumentsActions
                        permissions={this.props.permissions}
                        document={d}
                        user_mode={this.props.user_mode}
                        person_provider_id={this.props.personProviderId}
                        frequency={this.props.type}
                        />
                    </>
                    )}

                    {(
                    (this.props.type === 'only' || this.props.type === 'recurrent') &&
                    this.props.title !== 'Aprobados / Firmados' &&
                    this.props.title !== 'Aprobados' 
                    ) && (
                    <>
                        <DocumentsActions
                        param={this.props.param}
                        user_mode={this.props.user_mode}
                        document={d}
                        title={d.document.title}
                        section={this.props.section}
                        person_provider_id={this.props.personProviderId}
                        frequency={d.document.frequency}
                        permissions={this.props.permissions}
                        />
                    </>
                    )}
                </tr>
                ))}
            </>
        );
    }
}
export default DossierDocumentsTable;

if (document.getElementById('DossierDocumentsTable')) {
    ReactDOM.render(<DossierDocumentsTable />, document.getElementById('DossierDocumentsTable'));
}
